import { render, staticRenderFns } from "./forgotPassword.vue?vue&type=template&id=51c1256b&scoped=true"
import script from "./forgotPassword.vue?vue&type=script&lang=js"
export * from "./forgotPassword.vue?vue&type=script&lang=js"
import style0 from "./forgotPassword.vue?vue&type=style&index=0&id=51c1256b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c1256b",
  null
  
)

export default component.exports